/**
 * 根据视口宽度计算 Element 弹窗宽度与是否视为移动端（与 xfans_header 原逻辑一致）。
 * @param {number} clientWidth - 通常为 document.body.clientWidth
 * @returns {{ dialogWidth: string, isMobile: boolean }}
 */
export function getDialogSizeByViewport(clientWidth) {
  if (clientWidth <= 768) {
    return { dialogWidth: "90%", isMobile: true };
  }
  if (clientWidth >= 768 && clientWidth <= 1660) {
    return { dialogWidth: "40%", isMobile: false };
  }
  return { dialogWidth: "25%", isMobile: false };
}
